//会員登録
document.addEventListener('DOMContentLoaded', function () {
  const termsCheckbox = document.querySelector('.js-terms');
  const policyCheckbox = document.querySelector('.js-policy');
  const submitButton = document.querySelector('.js-submit');

  // .js-submit が存在しない場合は処理を終了
  if (!submitButton) return;

  function toggleSubmitButton() {
      submitButton.disabled = !(termsCheckbox?.checked && policyCheckbox?.checked);
  }

  // 初回チェック（ページ読み込み時）
  toggleSubmitButton();

  // チェックボックスが存在する場合のみイベントを設定
  termsCheckbox?.addEventListener('change', toggleSubmitButton);
  policyCheckbox?.addEventListener('change', toggleSubmitButton);
});

//会員登録 言語送信
function setLanguageInput() {
    const url = window.location.href; // 現在のページURLを取得
    const match = url.match(/\.com\/(.*?)\/account\//); // ".com/" と "/account/" の間を取得
    const langCode = match ? match[1] : ""; // 言語コードを取得（なければ空）

    // 言語コードに応じたマッピング
    const languageMap = {
        "en": "English",
        "zh-hans": "簡体中文",
        "zh-hant": "繁體中文"
    };

    // 言語名を取得（該当なしなら "日本語"）
    const language = languageMap[langCode] || "日本語";

    // URLの言語コードと選択された国を組み合わせて value を設定
    const selectedCountry = document.querySelector('#RegisterForm-country')?.value || "";
    const languageValue = `country:${selectedCountry},language:${language}`;

    // id="customer_tag" の input を取得し、value を更新
    const input = document.querySelector('#customer_tag');
    if (input) {
        input.value = languageValue;
    }

}

// ページ読み込み時に実行
document.addEventListener("DOMContentLoaded", setLanguageInput);

// select タグで選択変更時に再度 value を更新
document.querySelector('#RegisterForm-country')?.addEventListener('change', setLanguageInput);


//地図ページ
document.addEventListener("DOMContentLoaded", () => {
  const links = {
    oceania: "http://oceaniaURL.com",
    unitedstates: "http://unitedstatesURL.com",
    latinamerica: "http://latinamericaURL.com",
    canada: "http://canadaURL.com",
    africa: "http://africaURL.com",
    asia: "http://asiaURL.com",
    europe: "http:/europeURL.com",
  };

  document.querySelectorAll(".js-maparea").forEach(element => {
    element.addEventListener("click", (event) => {


      const area = element.getAttribute("data-area");
      const mapButton = document.querySelector(".js-mapbutton");

      if (mapButton && links[area]) {
        mapButton.href = links[area]; 
        mapButton.classList.remove("is-nolink");
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".js-maparea");
  console.log(elements); // 取得できているか確認
});

//外部リンク
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
   links[i].target = '_blank';
   links[i].rel = 'noreferrer noopener';
  }
}